export default function CallResponse(handle, {
    groupHandle,
    activeClass,
}) {

    const groups = handle.querySelectorAll(groupHandle);

    function addObserver(el, options) {
        // Check if `IntersectionObserver` is supported
        if (!('IntersectionObserver' in window)) {
            if (options.cb) {
                options.cb(el);
            } else {
                entry.target.classList.add(activeClass);
            }

            // We don't need to execute the rest of the code
            return
        }

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (options.cb) {
                        options.cb(el);
                    } else {
                        entry.target.classList.add(activeClass);
                        setTimeout(() => {
                            entry.target.classList.add('has-animated');
                        }, 7500);
                    }

                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(el);
    }

    function handleScroll(els, options = {}) {
        // let els = document.querySelectorAll(selector);
        els = Array.from(els);
        els.forEach(el => {
            addObserver(el, options);
        });
    }

    handleScroll(groups, {
        //rootMargin: '-500px'
    });
}
